import { useRenderNotifier } from '@wui/common-library'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useBlfStore } from '@/features/blf'

import { useUserData, UserFields } from '@/shared/composables/local-storage'
import { useLocalization } from '@/shared/composables/localization'
import { UserRoles } from '@/shared/types/router'
import { SUPPORT_SETTINGS_EQUIPMENT_LIST } from '@/shared/utils/constants'

export const functionalKeysBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const storeSettingsBlf = useBlfStore()
  const { fetch } = storeSettingsBlf
  const { t } = useLocalization()
  const { getField } = useUserData()
  const { notifyError } = useRenderNotifier()

  try {
    await fetch(to.params.mac as string)

    next()
  } catch (e: unknown) {
    const mac = to.params.mac as string
    if (storeSettingsBlf.blf.has(mac)) {
      next()
      return
    }

    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
    const name = getField(UserFields.USER_ROLE) === UserRoles.SUPPORT ? SUPPORT_SETTINGS_EQUIPMENT_LIST : 'equipment'
    next({ name })
  }
}
